import Page from "webPage/Page";
import AboutPersonModal from "modal/AboutPersonModal";
import StickySection from "util/StickySection";
import $ from "jquery";
import {handleAccordion} from "../util/LogoSection";

Page.register('page-template-about', () => {
    $('body').on('click', '.js-person-modal', function () {
        let data = JSON.parse($(this).find('.js-person-data').text());
        (new AboutPersonModal(data)).show();
        return false;
    }).on('click', '.js-modal-close', function () {
        $(this).parents('.modal').remove();
        $('body').removeClass('modal-active');
        return false;
    })

    handleAccordion();

    new StickySection($('.js-sticky-section'));
});
